/** Device id + remembered-PIN-email persistence for quick PIN sign-in.
 *
 * • `getDeviceId()` lazily mints a uuid v4 and caches it in localStorage so the same
 *   browser keeps the same device identity across sessions. Used as the second
 *   factor when authenticating with a PIN.
 * • `getPinEmail()` / `setPinEmail()` / `clearPinEmail()` remember which account
 *   previously enabled PIN on this device. Lets the login screen go straight to the
 *   numeric pad instead of asking for an email.
 */
const DEVICE_KEY = "pp_device_id";
const PIN_EMAIL_KEY = "pp_pin_email";

function uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function getDeviceId() {
  let id = localStorage.getItem(DEVICE_KEY);
  if (!id) {
    id = uuid();
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

export function getPinEmail() {
  return localStorage.getItem(PIN_EMAIL_KEY) || "";
}

export function setPinEmail(email) {
  if (email) localStorage.setItem(PIN_EMAIL_KEY, email.toLowerCase());
}

export function clearPinEmail() {
  localStorage.removeItem(PIN_EMAIL_KEY);
}
